import type { PaymentReconciliation } from "../types"
import { Link } from "@smooth/design-system-components"

/** 入金に紐づく消込を「ID・支払予定・金額」で並べる（admin の一覧・詳細と同じ） */
export const PaymentReconciliations = ({
  reconciliations,
}: {
  reconciliations: PaymentReconciliation[]
}) => (
  <ul className="flex flex-col gap-1">
    {reconciliations.map((reconciliation) => (
      <li key={reconciliation.id} className="flex gap-2">
        {reconciliation.id === null ? null : (
          <Link href={`/admin/reconciliations/${reconciliation.id}`}>{reconciliation.id}</Link>
        )}
        <span>Payment Promise</span>
        {reconciliation.paymentPromiseId === null ? null : (
          <Link href={`/admin/payment-promises/${reconciliation.paymentPromiseId}`}>
            {reconciliation.paymentPromiseId}
          </Link>
        )}
        <span>{reconciliation.amount}円</span>
      </li>
    ))}
  </ul>
)
